import initSliderValuation from './slider';

const activeTabClass = 'valuation-tab-active';

const initValuationTabs = (sliderId: string): void => {
  const valuationSwiper = initSliderValuation(sliderId);

  const tabs = document.querySelectorAll<HTMLElement>('.valuation-tab');
  tabs[0]?.classList.add(activeTabClass);

  Array.prototype.forEach.call(tabs, (tab: HTMLElement) => {
    tab.addEventListener('click', (event: Event) => {
      event.preventDefault();

      if (!tab.classList.contains(activeTabClass)) {
        const activeTab = document.querySelector<HTMLElement>(`.${activeTabClass}`);

        if (activeTab) {
          activeTab.classList.remove(activeTabClass);
        }

        tab.classList.add(activeTabClass);

        valuationSwiper.slideTo(parseInt(tab.dataset.tabIndex ?? '0', 10));
      }
    });
  });
};

export default initValuationTabs;
